<template>
     <input type="checkbox" id="modal-image" class="modal-toggle"/>
    <div class="modal">
        <div class="modal-box relative">
            <label for="modal-image"
                class="btn btn-sm btn-circle absolute btn-ghost left-2 top-2 pt-1 z-50">✕</label>
            <img :src="image" alt="image" class="mx-auto rounded-xl">
        </div>
    </div>
</template>
<script setup>
defineProps(['image']);
</script>